// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2u4gM","selects":"Documents_selects__3F8qT"};